import React from "react";
import { HEXLoadingSpinnerIcon } from "@icons/hexpert/HEXLoadingSpinnerIcon";
import './WeFitLoadingBlock.scss';

export const WeFitLoadingBlock = () => {
  return (
    <div className={"c-hex-loading-block"}>
      <HEXLoadingSpinnerIcon />
    </div>
  );
};
